import React, { useMemo } from "react";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../../Utils/renderField/renderReadField";
import { formatIdBultoSkim } from "../../../../../helpers/formatValues";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import { groupCargasByAlmacenBulto } from "../../../../helpers/groupCargas";
import {
    formatDetalleReproceso,
    unirDetallesReproceso,
} from "../../../../helpers/detalleReproceso";
const eliminarIcon = require("assets/img/icons/borrar.png");

export const CargasTable = (props) => {
    const { cargasTancada, modoResumen, EliminarCargaTancada } = props;

    const cargasAgrupadas = useMemo(() => {
        return groupCargasByAlmacenBulto(cargasTancada);
    }, [cargasTancada]);

    const TablaDetalle = (
        <div className="new-table-wrapper cargas-tancada__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ACCIONES</th>
                        <th>ALMACÉN</th>
                        <th>MATERIA PRIMA</th>
                        <th>KG HÚMEDOS</th>
                        <th>DRC</th>
                        <th>KG SECOS</th>
                    </tr>
                </thead>
                <tbody>
                    {cargasTancada.length === 0 && (
                        <tr>
                            <td className="text-center" colSpan={6}>
                                No se han agregado cargas a esta tancada
                            </td>
                        </tr>
                    )}
                    {cargasTancada.map((item, index) => {
                        // de dónde salió el reproceso de esta carga
                        const detalleReproceso = formatDetalleReproceso(
                            item.detalle_reproceso,
                        );

                        return (
                            <tr key={index}>
                                <td className="text-center text-nowrap">
                                    <div className="table-actions">
                                        <img
                                            src={eliminarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() =>
                                                EliminarCargaTancada(item.id)
                                            }
                                        />
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.almacen && item.almacen.nombre}
                                    {item.bulto_skim &&
                                        " - " +
                                            formatIdBultoSkim(item.bulto_skim)}
                                </td>
                                <td className="text-center text-nowrap cargas-tancada__table-ellipsis-cell">
                                    {item.almacen &&
                                        item.almacen.materia_prima &&
                                        item.almacen.materia_prima.nombre}
                                </td>
                                <td
                                    className="text-center text-nowrap"
                                    title={detalleReproceso}
                                    style={
                                        detalleReproceso
                                            ? { cursor: "help" }
                                            : {}
                                    }
                                >
                                    <RenderKilogramo
                                        value={item.kg_humedos}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.drc}>
                                        <RenderNumberPercentage
                                            value={item.drc}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td
                                    className="text-center text-nowrap"
                                    title={detalleReproceso}
                                    style={
                                        detalleReproceso
                                            ? { cursor: "help" }
                                            : {}
                                    }
                                >
                                    <NullableValue value={item.kg_secos}>
                                        <RenderKilogramo
                                            value={item.kg_secos}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );

    const TablaResumen = (
        <div className="new-table-wrapper cargas-tancada__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ALMACÉN</th>
                        <th>MATERIA PRIMA</th>
                        <th>KG HÚMEDOS</th>
                        <th>DRC</th>
                        <th>KG SECOS</th>
                    </tr>
                </thead>
                <tbody>
                    {cargasAgrupadas.length === 0 && (
                        <tr>
                            <td className="text-center" colSpan={5}>
                                No se han agregado cargas a esta tancada
                            </td>
                        </tr>
                    )}
                    {cargasAgrupadas.map((item, index) => {
                        // el reproceso de todas las cargas del almacén, sumado
                        // por pallet y por producto
                        const detalleReproceso = formatDetalleReproceso(
                            unirDetallesReproceso(item.items),
                        );

                        return (
                            <tr key={index}>
                                <td className="text-center text-nowrap">
                                    {item.almacen && item.almacen.nombre}
                                    {item.bulto_skim &&
                                        " - " +
                                            formatIdBultoSkim(item.bulto_skim)}
                                </td>
                                <td className="text-center text-nowrap cargas-tancada__table-ellipsis-cell">
                                    {item.almacen &&
                                        item.almacen.materia_prima &&
                                        item.almacen.materia_prima.nombre}
                                </td>
                                <td
                                    className="text-center text-nowrap"
                                    title={detalleReproceso}
                                    style={
                                        detalleReproceso
                                            ? { cursor: "help" }
                                            : {}
                                    }
                                >
                                    <RenderKilogramo
                                        value={item.kg_humedos}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.drc}>
                                        <RenderNumberPercentage
                                            value={item.drc}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td
                                    className="text-center text-nowrap"
                                    title={detalleReproceso}
                                    style={
                                        detalleReproceso
                                            ? { cursor: "help" }
                                            : {}
                                    }
                                >
                                    <NullableValue value={item.kg_secos}>
                                        <RenderKilogramo
                                            value={item.kg_secos}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );

    return modoResumen ? TablaResumen : TablaDetalle;
};
